<template>
    <div>
        <div class="box view-nav-bar">
            <div class="d-flex align-items-center w-100">
                <span class="text-muted">Admissions per year — all saleshouses vs <strong>BF</strong> only</span>
            </div>
        </div>

        <div v-if="loading" class="box">
            <div class="box-content text-center text-muted py-4">Loading…</div>
        </div>

        <div v-else-if="!rows.length" class="box">
            <div class="box-content text-center text-muted py-4">No admissions data found.</div>
        </div>

        <div v-else class="box">
            <div class="box-content">
                <table class="shx-table w-100 mt-2">
                    <thead>
                        <tr>
                            <th class="shx-th-100">Year</th>
                            <th class="text-right">Admissions (all)</th>
                            <th class="text-right">Admissions (BF)</th>
                            <th class="text-right shx-th-100"># Weeks</th>
                            <th class="text-right shx-th-100"># Cinemas</th>
                            <th class="text-right shx-th-100"># Titles</th>
                            <th class="shx-th-120"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rows" :key="row.year">
                            <td>
                                <router-link :to="'/admissions/year/' + row.year">{{ row.year }}</router-link>
                            </td>
                            <td class="text-right">{{ formatInt(row.admissions) }}</td>
                            <td class="text-right">{{ formatInt(row.admissions_bf) }}</td>
                            <td class="text-right">{{ row.weeks }}</td>
                            <td class="text-right">{{ row.cinemas }}</td>
                            <td class="text-right">{{ row.titles }}</td>
                            <td>
                                <router-link :to="'/admissions/year/' + row.year"
                                             class="btn btn-sm btn-outline-secondary">
                                    Per Week
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td><strong>Total</strong></td>
                            <td class="text-right"><strong>{{ formatInt(totalAdmissions) }}</strong></td>
                            <td class="text-right"><strong>{{ formatInt(totalAdmissionsBf) }}</strong></td>
                            <td colspan="4"></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AdmissionsByYear',
    data() {
        return {
            loading: true,
            rows: [],
        };
    },
    computed: {
        totalAdmissions() {
            return this.rows.reduce((sum, r) => sum + (r.admissions || 0), 0);
        },
        totalAdmissionsBf() {
            return this.rows.reduce((sum, r) => sum + (r.admissions_bf || 0), 0);
        },
    },
    created() {
        this.loadYears();
    },
    methods: {
        loadYears() {
            this.loading = true;
            axios
                .get('/admissions/year')
                .then(response => {
                    this.rows = response.data.data.rows || [];
                })
                .catch(error => {
                    this.$toast.error(error.response?.data?.error?.message || error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatInt(v) {
            return Math.round(v || 0).toLocaleString();
        },
    },
};
</script>
